module.exports = __webpack_public_path__ + "img/redeem-disable-icon.80224a82.png";